/**
 * CalendarDay - Individual day cell in attendance calendar
 */
import { Edit3 } from "lucide-react";

export const CalendarDay = ({ day, isWeekend, isPresent, isToday, isFuture, onClick, canOverride, onOverride }) => {
  let bgColor = "bg-gray-100";
  let textColor = "text-gray-400";
  
  if (!isWeekend && day.date) {
    if (isFuture) {
      bgColor = "bg-gray-50";
      textColor = "text-gray-400";
    } else if (isPresent) {
      bgColor = "bg-green-100";
      textColor = "text-green-700";
    } else {
      bgColor = "bg-red-50";
      textColor = "text-red-500";
    }
  }
  
  if (isToday) {
    bgColor += " ring-2 ring-blue-500";
  }
  
  return (
    <button
      onClick={canOverride && !isWeekend ? onOverride : onClick}
      disabled={isWeekend}
      className={`aspect-square rounded-lg ${bgColor} ${textColor} font-bold text-xs sm:text-sm flex items-center justify-center transition-all relative group`}
    >
      {day.day || ""}
      {canOverride && !isWeekend && day.date && (
        <div className="absolute inset-0 bg-purple-500/0 group-hover:bg-purple-500/20 rounded-lg transition-all flex items-center justify-center">
          <Edit3 className="w-3 h-3 opacity-0 group-hover:opacity-100 text-purple-600" />
        </div>
      )}
    </button>
  );
};
